/*
 * Pop Convert (Newsletter-Popup) rendert in einen Shadow-DOM:
 * Host ist <div id="pop-convert-app">, Modus `open`. Stylesheets der Seite
 * enden an dieser Grenze — anders als beim Cookie-Banner reicht Theme-CSS
 * hier NICHT. Ein <style> muss in den Shadow-Baum hinein.
 *
 * Warum nicht einfach in der App einstellen: die Schrift-Auswahl von Pop
 * Convert speist sich aus Shopifys Font-Bibliothek (Systemschriften, ein Teil
 * von Google Fonts, lizenziertes Monotype). Switzer kommt von Fontshare und
 * liegt selbst gehostet im Theme — es steht in dieser Liste nicht und laesst
 * sich dort auch nicht nachtragen.
 *
 * Die @font-face-Regeln aus `movasana-fonts.liquid` gelten weiter: Schriften
 * werden pro Dokument geladen, nicht pro Shadow-Baum. Hier muss also nur die
 * `font-family` gesetzt werden, keine zweite Ladung.
 */
(() => {
  const HOST = '#pop-convert-app';
  const MARKE = 'data-mv-schrift';

  const REGELN = `
    :host,
    :host :not(i):not(svg):not([class*="icon"]):not([class*="fa-"]) {
      font-family: 'Switzer', system-ui, -apple-system, 'Segoe UI', sans-serif !important;
    }
  `;

  const einsetzen = (host) => {
    const root = host.shadowRoot;
    if (!root || root.querySelector(`style[${MARKE}]`)) return;
    const style = document.createElement('style');
    style.setAttribute(MARKE, '');
    style.textContent = REGELN;
    // Als letztes Kind: schlaegt die App-Styles bei gleicher Spezifitaet.
    root.appendChild(style);
  };

  const suchen = () => {
    const host = document.querySelector(HOST);
    if (host && host.shadowRoot) einsetzen(host);
  };

  suchen();

  /* Die App haengt Host und Shadow-Baum verzoegert ein und baut den Inhalt
     bei jedem Kampagnenwechsel neu — deshalb dauerhaft beobachten statt
     einmal zu pruefen. */
  new MutationObserver(suchen).observe(document.body, { childList: true, subtree: true });
})();
